import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
// Lodash
import _isEmpty from 'lodash/isEmpty';

// Utils
import { getStartOfDayEpoch, getEndOfDayEpoch } from '@tekion/tekion-base/utils/dateUtils';

// Constants
import { EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
export var getDateRangeValue = function getDateRangeValue(value) {
  if (_isEmpty(value)) return EMPTY_ARRAY;
  var _value = _slicedToArray(value, 3),
    startMoment = _value[0],
    endMoment = _value[1],
    additional = _value[2];
  var startOfDayEpoch = getStartOfDayEpoch(startMoment);
  var endOfDayEpoch = getEndOfDayEpoch(endMoment);
  return [startOfDayEpoch, endOfDayEpoch, additional];
};